import { render, staticRenderFns } from "./sensors.vue?vue&type=template&id=146121a6"
import script from "./sensors.vue?vue&type=script&lang=js"
export * from "./sensors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports